<template>
    <div class="alert alert-info" role="alert">
        <span class="alert-icon" aria-hidden="true" />
        <div class="alert-content">
            <a
                :href="linkUrl"
                class="o-link-arrow ob1-link-dark o-link-small"
            >{{ message }}</a>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        linkUrl: {
            type: String,
            required: true
        },
        message: {
            type: String,
            required: true
        },
    },

}
</script>

<style scoped lang="scss">

.alert-wrapper .alert {
    display: inline-flex;
    padding: 0 22px 0 7px;
}

.alert .alert-icon {
    font-size: 24px;
}

.alert-wrapper .o-link-arrow {
    max-width: 100%;
}

</style>
